<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>

<template>
	<div :key="'default'" id="list-customers" class="data-list-container">
		<customer-form-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" @refetchDataList="getListCustomers(true)" :data="sidebarData" />

		<div class="dropdown-button-container flex justify-end md:hidden lg:hidden xl:hidden">
			<vs-input @input="mixinHandleSearch" size="small" class="input-search mr-3" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />

			<vs-dropdown vs-custom-content vs-trigger-click>
				<vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
				<vs-dropdown-menu>
					<vs-dropdown-item divider v-if="mixinIsCanCreateCustomer">
						<vs-button class="w-48 font-bold" type="filled" @click="addNewData">{{ $t("AddNewCustomer") }}</vs-button>
					</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>

		<vs-table ref="table" class="stack-table" :sst="true" :data="customers" :max-items="itemsPerPage" :noDataText="$t('Notify.NoDataAvailable')" @sort="mixinHandleSort">
			<div slot="header" class="flex flex-grow justify-end">
				<vs-input @input="mixinHandleSearch" size="large" class="input-search mr-3 md:block lg:block xl:block hidden" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />
				<vs-button :disabled="disableButtonDivision" type="border" class="mr-3" @click.stop="toggleDivisionDialog(true)">
					<p class="font-bold">{{ $t("Division") }}</p>
				</vs-button>
				<cbs-upload-ref
					:limit="1"
					class="mr-3"
					displayMode="button"
					:title="$t('ImportCustomer')"
					:isEditable="true"
					v-model="importFileCustomer"
					:key="'customers--import'"
					accept=".xls,.xlsx"
				/>
				<cbs-upload-ref
					:limit="1"
					class="mr-3"
					displayMode="button"
					:title="$t('ImportCustomerDebts')"
					:isEditable="true"
					v-model="importFileDebts"
					:key="'customers--import-debts'"
					accept=".xls,.xlsx"
				/>
				<vs-button type="border" class="mr-3" @click.stop="handleExportReport">
					<p class="font-bold">{{ $t("Report") }}</p>
				</vs-button>

				<div class="md:flex lg:flex xl:flex hidden">
					<vs-button v-if="mixinIsCanCreateCustomer" class="w-30 font-bold" type="filled" @click="addNewData">{{ $t("Actions.Create") }}</vs-button>
				</div>
			</div>

			<template slot="thead">
				<vs-th class="no-sorter justify-center flex"><vs-checkbox v-model="selectAllCustomer"></vs-checkbox></vs-th>
				<vs-th class="no-sorter">{{ $t("GroupCustomer") }}</vs-th>
				<vs-th sort-key="code">{{ $t("Code") }}</vs-th>
				<vs-th sort-key="name" class="custom-sort-filter">{{ $t("FullName") }}</vs-th>
				<vs-th sort-key="limit">{{ $t("Limit") }}</vs-th>
				<vs-th class="no-sorter"></vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr class="cursor-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td><vs-checkbox @change="onChangeCheckBox" :disabled="!tr.can_update_accessables" v-model="selectCustomer[tr.id]"></vs-checkbox></vs-td>
						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('GroupCustomer')">
							<p class="text-base">{{ tr.group }}</p>
						</vs-td>
						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Code')">
							<p class="text-base">{{ tr.code }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('FullName')">
							<p v-if="getCustomerDecentralizedAccess(tr.c_permissions, 'name', 'view')" class="text-base">{{ tr.name }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Limit')">
							<p v-if="getCustomerDecentralizedAccess(tr.c_permissions, 'debt_limit', 'view')" class="text-base">{{ $helper.numFormat(tr.debt_limit) }}</p>
						</vs-td>

						<vs-td class="whitespace-no-wrap text-right">
							<CustomerContextMenu type="vertical" :customerItem="tr" @onClickAddTTYT="handleAddTTYT" @onClickAddDebts="handleAddDebts" @onClickDebtExtension="handleDebtExtension" @onClickEdit="editData" />
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<CbsPagination class="mt-3" :total="totalPages" v-model="currentPage" />
		<CustomerTTYTFormSideBar
			v-if="customerTTYTDialogData"
			:debtFormTitle="debtFormTitle"
			:data="customerTTYTDialogData"
			:isSidebarActive="isCustomerTTYTFormDialogActive"
			@closeSidebar="toggleCustomerTTYTFormSidebar"
		/>
		<CustomerDebtFormSideBar
			v-if="customerDebtDialogData"
			:debtFormTitle="debtFormTitle"
			:data="customerDebtDialogData"
			:isSidebarActive="isCustomerDebtFormDialogActive"
			@closeSidebar="toggleCustomerDebtFormSidebar"
		/>
		<CustomerDetailDialog
			v-if="isDetailCustomerDialogActive"
			:customer="detailCustomerDialogData"
			:isSidebarActive="isDetailCustomerDialogActive"
			@closeSidebar="toggleCustomerDetailSidebar"
			@onClickAddTTYT="handleAddDebts"
			@onClickAddDebts="handleAddDebts"
			@onClickDebtExtension="handleDebtExtension"
			@onClickEdit="editData"
		/>
		<CustomersDivisionDialog :isSidebarActive="isDivisionDialogActive" :data="dataDivisionDialog" @closeSidebar="toggleDivisionDialog" />
	</div>
</template>

<script>
// import _ from "lodash";
import { withBasicQueries, customerPermissions, getUserPermissions } from "@/mixins/mixins.js";
import { mapGetters } from "vuex";
import moduleCustomer from "@/store/customer/moduleCustomer";
import customerGql from "@/http/requests/card/customer_gql";
import CustomerFormSidebar from "./CustomerFormSidebar";
import CustomerContextMenu from "./CustomerContextMenu";
import CustomerDebtFormSideBar from "./CustomerDebtFormSideBar";
import CustomerTTYTFormSideBar from "./CustomerTTYTFormSideBar";
import CustomerDetailDialog from "./CustomerDetailDialog";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import { find as findLodash, mapKeys } from "lodash";
import CustomersDivisionDialog from "./CustomersDivisionDialog";
import moduleDepartment from "@/store/department/moduleDepartment";

export default {
	mixins: [
		withBasicQueries,
		getUserPermissions({
			...customerPermissions
		})
	],
	components: {
		CustomerFormSidebar,
		CustomerContextMenu,
		CustomerDebtFormSideBar,
		CustomerTTYTFormSideBar,
		CustomerDetailDialog,
		CbsUploadRef,
		CustomersDivisionDialog
	},
	data() {
		return {
			itemsPerPage: 10,
			searchText: "",

			// Data Sidebar
			addNewDataSidebar: false,
			sidebarData: {},
			customerDebtDialogData: null,
			isCustomerDebtFormDialogActive: false,
			customerTTYTDialogData: null,
			isCustomerTTYTFormDialogActive: false,
			isDetailCustomerDialogActive: false,
			detailCustomerDialogData: null,
			importFileCustomer: null,
			importFileDebts: null,
			selectCustomer: {},
			selectAllCustomer: null,
			isDivisionDialogActive: false,
			disableButtonDivision: true,
			dataDivisionDialog: null,
			debtFormTitle: null
		};
	},
	computed: {
		...mapGetters({
			getParsedCustomers: "customerManagement/getParsedCustomers"
		}),
		customers() {
			return this.getParsedCustomers || [];
		},
		totalPages() {
			return Math.ceil(this.$store.state.customerManagement.total / this.$store.state.customerManagement.limitPerPage);
		}
	},
	watch: {
		currentPage() {
			this.selectAllCustomer = false;
			this.disableButtonDivision = true;
			this.selectCustomer = {};
			this.getListCustomers();
		},
		"$route.query"() {
			this.getListCustomers();
		},
		importFileCustomer() {
			if (this.importFileCustomer && this.importFileCustomer.length > 0) {
				this.handleImportCustomerFile();
			}
		},
		importFileDebts() {
			if (this.importFileDebts && this.importFileDebts.length > 0) {
				this.handleImportCustomerDebts();
			}
		},
		selectAllCustomer(val) {
			this.customers.map(item => {
				if (item.can_update_accessables) {
					this.selectCustomer[item.id] = val;
					this.disableButtonDivision = !val;
				}
			});
		}
	},
	methods: {
		async getListCustomers(isRefetch = false) {
			try {
				this.$vs.loading();
				// const filter = this.$route.params.filter || {};
				const queryOptions = {
					limit: this.$store.state.customerManagement.limitPerPage,
					page: this.currentPage,
					orderBy: this.orderBy
				};
				if (isRefetch) {
					queryOptions.fetchPolicy = "no-cache";
				}

				if (this.searchText) {
					queryOptions.search = this.searchText;
				}

				// Fetch customers
				try {
					await this.$store.dispatch("customerManagement/fetchCustomersManagement", queryOptions);
				} catch (error) {
					console.error(error);
				}
				// if (this.$refs.table && this.searchText) {
				// 	this.$refs.table.currentx = 1;
				// }
				// this.$store.commit("customerManagement/UPDATE_CUSTOMERS_FILTER", filter);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		addNewData() {
			this.sidebarData = {};
			this.toggleDataSidebar(true);
		},
		showDeleteConfirm(id) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteData(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteData(id) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("customerManagement/deleteCustomer", id);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteCustomerSuccessful")
					}
				});
			} catch (error) {
				console.error("error", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async editData(cus) {
			try {
				this.$vs.loading();
				const response = await customerGql.getCustomerDetail({ id: cus.id });

				this.sidebarData = {
					...response.customer
				};

				this.toggleDataSidebar(true);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
		},
		handleAddDebts(cus) {
			this.isCustomerDebtFormDialogActive = true;
			this.customerDebtDialogData = cus;
		},
		handleAddTTYT(cus) {
			this.isCustomerTTYTFormDialogActive = true;
			this.customerTTYTDialogData = cus;
		},
		handleDebtExtension(cus) {
			this.debtFormTitle = "Actions.DebtExtension";
			this.handleAddDebts(cus);
		},

		toggleCustomerDebtFormSidebar(val = false) {
			this.debtFormTitle = "CreateDebt";
			this.isCustomerDebtFormDialogActive = val;
		},
		toggleCustomerTTYTFormSidebar(val = false) {
			this.isCustomerTTYTFormDialogActive = val;
		},
		toggleCustomerDetailSidebar(val = false) {
			this.isDetailCustomerDialogActive = val;
		},
		handleClickItemRow(event, customer) {
			const eventClasses = event.target && event.target.className;
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find(className => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				this.detailCustomerDialogData = customer;
				this.toggleCustomerDetailSidebar(true);
			}
		},
		handleExportReport() {
			this.$router.history.push({
				name: this.$constant.PAGES_NAME.PAGE_CBS_CUSTOMER_DEBPT_REPORTING
			});
		},
		async handleImportCustomerFile() {
			this.$vs.loading();
			try {
				const response = await customerGql.importCustomers(this.importFileCustomer[0].id);
				let description = "";
				response.map(rs => {
					description = `${description} ${rs.display} ${this.$t("Customer")} ${this.$t(`ImportResult.${rs.type}`)}`;
				});
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: `${this.$t("Successful")}. ${description}`
					}
				});
				this.getListCustomers();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
				this.importFileCustomer = [];
			}
		},
		async handleImportCustomerDebts() {
			this.$vs.loading();
			try {
				const response = await customerGql.importCustomersDebts(this.importFileDebts[0].id);
				let description = "";
				response.map(rs => {
					description = `${description} ${rs.display} ${this.$t("Debt")} ${this.$t(`ImportResult.${rs.type}`)}`;
				});
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: `${this.$t("Successful")}. ${description}`
					}
				});
				this.getListCustomers();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
				this.importFileDebts = [];
			}
		},
		async toggleDivisionDialog(val) {
			if (val) {
				try {
					let customer_ids = [];
					mapKeys(this.selectCustomer, (val, key) => {
						customer_ids = val ? [...customer_ids, Number(key)] : [...customer_ids];
					});
					this.dataDivisionDialog = {
						customer_ids
					};
					await this.$store.dispatch("customerManagement/getCustomerAcccessableFields");
				} catch (error) {
					console.error("toggleDivisionDialog");
				}
			} else {
				this.dataDivisionDialog = null;
			}
			this.isDivisionDialogActive = val;
		},
		onChangeCheckBox() {
			let isDisable = true;
			const f = findLodash(this.selectCustomer, item => {
				return item === true;
			});
			if (f) {
				isDisable = false;
			} else {
				isDisable = true;
			}
			this.disableButtonDivision = isDisable;
		}
	},
	created() {
		this.$store.registerModule("customerManagement", moduleCustomer);
		this.$store.dispatch("customerManagement/setCustomersSearchQuery", "");
		this.$store.registerModule("departmentManagement", moduleDepartment);

		this.getListCustomers();
	},
	beforeDestroy() {
		this.$store.unregisterModule("customerManagement");
		this.$store.unregisterModule("departmentManagement");
	}
};
</script>

<style lang="scss">
// @import "@/assets/scss/cbs/CustomersManagement.scss";
</style>
